export const UNFIX_PLACEHOLDER_MESSAGE = '취소 사유를 입력해주세요';
export const SEARCH_PLACEHOLDER_MESSAGE = '검색어를 입력하세요...';
export const GATHERING_SEARCH_PLACEHOLDER_MESSAGE = '제목, 내용으로 검색';
export const BOARD_GAME_SEARCH_PLACEHOLDER_MESSAGE = '이름, 설명으로 검색';
